import styled from 'styled-components';

const Wrap = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export default Wrap;
